export default __webpack_public_path__ + "static/media/Audio-wave.06cb1f08.svg";